import {createFileRoute} from '@tanstack/react-router';
import TournamentCreatePage from '../../../../tournaments/TournamentCreatePage.tsx';
import {SPORT_AREAS} from '../../../../sports/sportAreas.ts';

export const Route = createFileRoute('/_app/football/tournaments/new')({
    component: RouteComponent,
})

function RouteComponent() {
    return <TournamentCreatePage sport={SPORT_AREAS.football} />
}
